import IconButton from "@mui/material/IconButton";
import { MenuItem, Menu } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useState } from "react";
import "./MenuWithPDF.scss";

const MenuWithPDF = ({ options,handleDelete, id }) => {
  // console.log(id,"nature")
  const [anchorEl, setAnchorEl] = useState(null);
  const [openMenuIndex, setOpenMenuIndex] = useState(null);

  const handleMenuClose = () => {
    setAnchorEl(null);
    setOpenMenuIndex(null);
  };

  const handleMenuClick = (event, index) => {
    setAnchorEl(event.currentTarget);
    setOpenMenuIndex(index);
  };

  // Handle each specific action
  const handleAction = (option, event) => {
    event.stopPropagation();
    
    switch (option.label) {
      case "Scarica in pdf":
        if (option.action) option.action(id);
        break;
      case "Importa dati":
        if (option.action) option.action(id);
        break;
      case "Esporta dati":
        if (option.action) option.action(id);
        break;
      case "Elimina":
        if (option.action) option.action(id);
        break;
      case "Duplica":
        if (option.action) option.action(id);
        break;
      case "Pagamenti":
        if (option.action) option.action(id);
        break;
      case "Centri di costo":
        if (option.action) option.action(id);
        break;
      default:
        // For any other custom actions
        if (option.action) option.action(id);
    }
    
    handleMenuClose();
  };

  return (
    <div style={{ marginTop: "0" }}>
      <IconButton
        className="menuIconBtn"
        onClick={(e) => handleMenuClick(e, 0)}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl) && openMenuIndex === 0}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        className="pdfmenuoptional"
      >
        {options.map((option, index) => (
          <MenuItem
            key={index}
            sx={{
              "&:hover": {
                svg: {
                  color: "#57C700",
                },
              },
              // Add specific styling for different option types if needed
              color: option.label === "Pagamenti" ? "green" : "inherit",
            }}
            onClick={(event) =>{ handleAction(option, event); handleDelete(event, id)}}
          >
            {option.icon}
            {option.label}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};

export default MenuWithPDF;